import 'select2'

jQuery('.select2-filter').select2({
  minimumResultsForSearch: -1,
  placeholder: function () {
    jQuery(this).data('placeholder');
  },
  dropdownAutoWidth: true,
  dropdownCssClass: 'woocommerce-filtering-select2',
  selectionCssClass: 'woocommerce-filtering-select2-container'
}).on("select2:unselect", function (e) {
  var self = $(this);
  setTimeout(function () {
    self.select2('close');
  }, 0);
});

jQuery('.select2-filter').on('change', (e) => {
  const queryArray = jQuery('.woocommerce-filtering')
    .serializeArray()
    .filter(item => {
      return item.value.length
    })

  const query = queryArray.map(item => {
    return item.name + '=' + item.value
  }).join('&')

  //console.log(query)

  window.location = jQuery('.woocommerce-filtering').attr('action') + '?' + query;

  //jQuery('.woocommerce-filtering').submit()
})

jQuery('.select2-filter').on('select2:close', function (e) {
  let filterParams = new URLSearchParams(window.location.search)
  if (jQuery(e.target).val() == filterParams.get(jQuery(e.target).attr('name')))
    jQuery(e.target).val(null).trigger('change')
})

